function getPharmacyID(): string {
    if (!localStorage.getItem('pharmacyCode')) {
        return ""
    }
    return localStorage.getItem('pharmacyCode') || ""
}

export default getPharmacyID